import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import WorldCountriesQuiz from './pages/WorldCountriesQuiz/WorldCountriesQuiz';
import ForestDiversity from './pages/ForestDiversity/ForestDiversity';
import BirdMap from './pages/BirdMap/BirdMap';
import BioticIndex from './pages/BioticIndex/BioticIndex';
import MoonCards from './pages/MoonCards/MoonCards';
import Labs from './pages/Labs/Labs';
import RockCycleCanvas from './pages/RockCycleCanvas/RockCycleCanvas';
// Import other pages



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/world-countries-quiz" element={<WorldCountriesQuiz />} />
        <Route path="/forest-diversity" element={<ForestDiversity />} />
        <Route path="/bird-map" element={<BirdMap />} />
        <Route path="/biotic-index" element={<BioticIndex />} />
        <Route path="/moon-cards" element={<MoonCards />} />
        <Route path="/labs" element={<Labs />} />
        <Route path="/rock-cycle-canvas" element={<RockCycleCanvas />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}


export default App;
